import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class ChatNoAccessView extends React.PureComponent {
  render() {
    return (
      <div className="chat-no-access-view">
        <img
          src="img/no-chat.png"
          alt=""
          className="chat-no-access-view-illustration"
        />
        <p className="chat-no-access-view-title">
          <FormattedMessage
            id="chat_no_access_title"
            defaultMessage="No Chat"
            description="Title shown when user is not authenticated"
          />
        </p>
        <p className="chat-no-access-view-text">
          <FormattedMessage
            id="chat_no_access_message"
            defaultMessage="Dito mo makikita ang iyong chat for a limited time."
            description="Message shown when user is not authenticated"
          />
        </p>
      </div>
    );
  }
}
